



























































































































import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";

import {
  InternalMonthlySummarizeDto,
  InternalMonthlySummarizeDtoPagedResultDto,
  PayType,
  AuditFlowScope,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
// import EditLink from "@/views/project/internalMonthlySummarize/editBeneficiary.vue";
// import SummarizeDetail from "@/views/project/internalMonthlySummarize/detail.vue";

@Component({
  name: "InternalMonthlySummarizeList",
  components: {
    // EditLink,
    PagedTableView,
    AgileAuditTag,
    // SummarizeDetail
  },
})
export default class InternalMonthlySummarizeList extends Vue {
  queryForm: any = {
    displayName: "",
    date: "",
  };

  editLinkId = 0;
  private currentDetail: InternalMonthlySummarizeDto = {};

  created() {
    if (this.$route.query.date) {
      this.queryForm.date = this.$route.query.date;
    }
  }

  // 获取表数据
  fetchData(params: any) {
    console.log("test:" + params);
    return api.internalMonthlySummarize.getAll(params);
  }

  handleMenu($row: any) {
    switch ($row.type) {
      case "detail":
        this.handleDetail($row.item);
        break;

      case "edit":
        this.handleEdit($row.index, $row.item);
        break;

      case "delete":
        this.handleDelete($row.index, $row.item);
        break;

      case "startAudit":
        this.handleStartAudit($row.index, $row.item);
        break;
      case "auditFlow":
        this.handleAuditFlow($row.index, $row.item);
        break;
    }
  }

  handleCreate() {
    this.$router.push({
      name: "internalMonthlySummarizeCreate",
    });
  }

  // //编辑
  // handleEdit(index: number, row: InternalMonthlySummarizeDto) {
  //   this.editLinkId = row.id!;
  //   (this.$refs.editForm as any).show = true;
  //   (this.$refs.editForm as any).form = row;

  //   console.warn("%cu must reWrite this method", "color:#0048BA;");
  // }

  handleEdit(index: number, row: any) {
    this.$router.push({
      name: "internalMonthlySummarizeEdit",
      params: {
        id: row.id,
      },
    });
  }

  handleViewDetail(row: InternalMonthlySummarizeDto) {
    this.currentDetail = row;
    (this.$refs.summarizeDetail as any).show = true;
  }

  handleDetail(row: any) {
    this.$router.push({
      name: "internalMonthlySummarizeDetail",
      params: {
        id: row.id,
      },
    });
  }

  //  提交审核
  async handleStartAudit(index: number, row: InternalMonthlySummarizeDto) {
    // await api.internalMonthlySummarize
    //   .startAudit({body: {id: row.id}})
    //   .then(res => {
    //     this.$message.success("已提交");
    //   });
  }

  // 删除
  async handleDelete(index: number, row: InternalMonthlySummarizeDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.internalMonthlySummarize
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handleAuditFlow(index: number, row: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.InternalMonthlySummarize,
        hostId: row.id,
        auditFlowId: row.auditFlowId,
      },
    });
  }

  handelOnSaved() {
    this.fetchData(this.queryForm);
  }
}
